import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function BioSection() {
  return (
    <section
      id="biografia"
      data-testid="bio-section"
      className="py-24 md:py-32 bg-white border-t border-neutral-200"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 grid lg:grid-cols-12 gap-12 lg:gap-16">
        <div className="lg:col-span-4">
          <div className="text-[11px] uppercase tracking-[0.28em] text-[#003F88] font-semibold">
            <span className="accent-line" />
            Quem é Rosalvo
          </div>
          <h2 className="font-serif-display text-4xl md:text-5xl lg:text-6xl leading-[1.02] tracking-tight mt-6 text-neutral-900">
            Procurador, <em className="italic font-light">ex-vereador, ex-secretário</em> — sempre a serviço da cidade.
          </h2>

          <div className="mt-10 hidden lg:block">
            <img
              src="/photos/bio-community.jpg"
              alt="Rosalvo em audiência pública"
              data-testid="bio-image"
              className="editorial-img w-full h-[380px] object-cover"
            />
            <div className="mt-3 text-xs uppercase tracking-widest text-neutral-500">
              Audiência pública · escuta com a comunidade
            </div>
          </div>
        </div>

        <div className="lg:col-span-8">
          <p className="drop-cap font-body text-lg md:text-xl leading-relaxed text-neutral-700 font-light">
            Antônio Rosalvo é Procurador Municipal concursado, com sólida trajetória na administração
            pública e ampla experiência legislativa. Exerceu três mandatos como vereador,
            destacando-se pela atuação comprometida com o desenvolvimento social, institucional e
            urbano do município.
          </p>

          <p className="mt-6 font-body text-lg md:text-xl leading-relaxed text-neutral-700 font-light">
            Durante sua trajetória no Legislativo, presidiu a Câmara Municipal de Lauro de Freitas
            por três vezes, conduzindo os trabalhos com responsabilidade, diálogo e fortalecimento
            institucional. Também atuou como Secretário da SEDUR — Secretaria de Desenvolvimento
            Urbano — contribuindo para projetos e ações voltadas ao planejamento e desenvolvimento
            urbano da cidade.
          </p>

          <figure className="my-10 border-l-4 border-[#FFC72C] pl-6 md:pl-10">
            <blockquote
              data-testid="bio-pull-quote"
              className="font-serif-display italic text-2xl md:text-3xl lg:text-4xl leading-snug text-neutral-900"
            >
              “Apresentar resultados é a única forma de justificar um mandato público.”
            </blockquote>
            <figcaption className="mt-4 text-xs uppercase tracking-widest text-neutral-500">
              Antônio Rosalvo
            </figcaption>
          </figure>

          <p className="font-body text-lg md:text-xl leading-relaxed text-neutral-700 font-light">
            Reconhecido pela experiência administrativa, jurídica e política, Antônio Rosalvo mantém
            atuação pautada na defesa do interesse público, na ética e no compromisso com a gestão
            eficiente e transparente. Filho de pescador, morador do Jambeiro desde os 12 anos,
            transformou o ofício do direito em ofício do serviço público — e segue, hoje filiado ao
            PSDB, conectado com o futuro de Lauro de Freitas.
          </p>

          <Link
            to="/trajetoria"
            data-testid="bio-cta-trajectory"
            className="mt-10 inline-flex items-center gap-3 text-sm uppercase tracking-[0.2em] font-medium text-[#003F88] hover:text-[#002A5C] transition-colors"
          >
            Ver linha do tempo completa <ArrowRight size={16} />
          </Link>
        </div>
      </div>
    </section>
  );
}
